import { render, staticRenderFns } from "./productionstable.vue?vue&type=template&id=57b0548e&"
import script from "./productionstable.vue?vue&type=script&lang=js&"
export * from "./productionstable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports